import { ChangeDetectionStrategy, Component, computed, inject, Input, input} from '@angular/core';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { DocumentiSearchDocRow } from 'src/app/shared/models/documento-search.model';
import { OperazioniMassiveService } from '../services/operazioni-massive.service';
import { HeaderVersamentoOperazioniMassive } from '../models/operazioni-massive.model';

@Component({
  selector: 'app-riepilogo-versamenti',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="grid ">
      <div class="col-4">
        <p-card class="ml-2">
          <p class="m-0">Numero Nota: <span class= "font-bold">{{header()?.numeroNota}}</span></p>
          <p class="m-0">Data Versamento Documenti: <span class="font-bold">{{header()?.date | date: 'dd/MM/yyyy'}}</span></p>
          <p class="m-0">Note per il Registro: <span class="font-bold">{{noteToShow()}}</span></p>
        </p-card>
      </div>
      <div class="col-12">
        <p-table [value]="items()" styleClass="p-datatable-gridlines">
          <ng-template pTemplate="header">
              <tr>
                  <th class="text-center w-1">Qualifica e classifica di segretezza del documento</th>
                  <th class="text-center w-2">Numero di protocollo o di controllo del documento</th>
                  <th class="text-center w-3">Oggetto del documento</th>
                  <th class="text-center w-1">Data del Documento</th>
                  <th class="text-center w-1">Lingua in cui il documento è redatto</th>
                  <th class="text-center w-1">Stato del Documento</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
              <tr>
                  <td class="text-center">{{ item.classifica }} {{ item.qualifica }}</td>
                  <td class="text-center">{{ item.protocollo }}</td>
                  <td class="text-center">{{ item.oggetto }}</td>
                  <td class="text-center">{{ item.dataDocumento | date: "dd/MM/yyyy" }}</td>
                  <td class="text-center">{{ item.lingua }}</td>
                  <td class="text-center">{{ item.stato }}</td>
              </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-12 buttons flex justify-content-end gap-2">
        <button *ngIf="!showOnly()" pButton type="button" icon="fas fa-file-landmark" label="Conferma" title="Conferma" (click)="confirmPayment()"></button>
        <!-- <em>{{showOnly}}</em> -->
        <!-- <button pButton type="button" icon="fas fa-file-landmark" label="Conferma" title="Conferma" (click)="confirmPayment()"></button> -->
      </div>       
    </div>
  `
})
export class RiepilogoVersamentiComponent {
  private readonly confirmationService = inject(ConfirmationService);
  private readonly  messageService= inject(MessageService);
  private readonly operazioniMassiveService = inject(OperazioniMassiveService);
  
  header = input<HeaderVersamentoOperazioniMassive>();
  items = input<DocumentiSearchDocRow[]>([]);
  showOnly = input<boolean>(false);

  public noteToShow =  computed(() => {
    const header = this.header();
    if (header)
      return ( header.note.length <= 64)?header.note:`${header.note.substring(0,64)}...`;

    return '';
  });

  private doPayment(): void {

    const header = this.header();

    if (header)
      this.operazioniMassiveService.versamento( header, this.items())
        .subscribe( (res) => {
          let message : Message = { severity:'success', summary:'Versamento Massiva Documenti', detail:'Operazione completata con successo'};

          if (!res) {
            message = { severity:'error', summary:'Errore', detail:'Errore nella operazione di versamento massiva dei documenti selezionati'};
          }
          this.messageService.add(message);
        });
  }

  public confirmPayment(): void {

    this.confirmationService.confirm({
        message: 'Sei sicuro di voler procedere al versamento dei documenti selezionati?',
        header: 'Versamento Massiva di Documenti',
        icon: 'pi pi-exclamation-triangle',
        accept: () => this.doPayment(),
        //reject: () => this.cancelPayment()
    });
  }
}
